import React from 'react';
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import {
  renderEmailField,
  renderPhoneField,
  renderSelectField,
  phoneParser,
  phoneFormatter,
} from '../../../utils/redux-form-helper';

const DeleteButton = ({ onClick, disabled }) => (
  <a
    onClick={onClick}
    style={{
      display: 'flex',
      flex: '1',
      justifyContent: 'center',
      alignItems: 'center',
      height: '40px',
      width: '30px',
      cursor: disabled ? 'not-allowed' : 'pointer',
    }}
  >
    <i className="et-trash" />
  </a>
);

const DynamicContactField = ({
  fieldName,
  index,
  type, // 'email' or 'phone'
  typeOptions,
  onRemove,
  disabled,
  placeholder,
  validate,
  isPrimary,
  isLast,
  label,
  typeLabel,
}) => {
  const isEmail = type === 'email';
  const inputComponent = isEmail ? renderEmailField : renderPhoneField;
  const inputProps = isEmail
    ? {
        maxLength: '70',
      }
    : {
        parse: phoneParser,
        format: phoneFormatter,
      };

  return (
    <Row>
      <Col xs={6}>
        <Field
          name={`${fieldName}.${
            type === 'email' ? 'emailAddress' : 'phoneNumber'
          }`}
          component={inputComponent}
          placeholder={placeholder}
          disabled={disabled}
          validate={validate}
          label={label}
          showLabel={isPrimary}
          className="input-lg"
          {...inputProps}
        />
      </Col>
      <Col xs={5}>
        <Field
          name={`${fieldName}.${type === 'email' ? 'emailType' : 'phoneType'}`}
          component={renderSelectField}
          options={typeOptions}
          disabled={disabled}
          label={isPrimary ? typeLabel : undefined}
          bsSize="lg"
        />
      </Col>
      <Col>
        {!isPrimary && isLast && (
          <DeleteButton onClick={() => onRemove(index)} disabled={disabled} />
        )}
      </Col>
    </Row>
  );
};

export default DynamicContactField;
